const translations = {
  // Page headers / metadata
  title: "Orders",
  subtitle: "Browse, search, and manage customer jewelry design orders.",
  newOrder: "New Order",
  createOrder: "Create Order",
  orderDetail: "Order Detail",
  orderNotFound: "Order not found",
  orderNotFoundDesc: "It may have been removed.",
  backToOrders: "Back to orders",
  allOrders: "All orders",
  workflow: "Workflow",

  // Search & Filters
  searchPlaceholder: "Search by order no, customer, or item…",
  statusPlaceholder: "Status",
  allStatuses: "All statuses",
  orderTypePlaceholder: "Order type",
  allTypes: "All types",
  placeholderStatus: "Status",
  placeholderType: "Order type",

  // No Orders empty State
  noOrdersTitle: "No orders yet",
  noOrdersDesc: "Create the first order to begin the workflow.",

  // Table Headers
  orderNoCol: "Order No",
  dateCol: "Date",
  customerCol: "Customer",
  itemCol: "Item",
  typeCol: "Type",
  fineGoldCol: "Fine Gold",
  deliveryCol: "Delivery",
  statusCol: "Status",
  actionCol: "Action",

  // Table row text & badges
  delayed: "Delayed",
  tomorrow: "Tomorrow",
  today: "Today",
  remind: "Remind",
  view: "View",

  // Badges & Labels
  status_draft: "Draft",
  status_confirmed: "Confirmed",
  status_awaiting_job_card: "Awaiting Job Card",
  status_in_production: "In Production",
  status_ready_billing: "Ready for Billing",
  status_delivered: "Delivered",
  status_cancelled: "Cancelled",
  status_received: "Received",
  status_gold_received: "Gold Received",
  status_gold_issued: "Gold Issued",
  status_sent_to_worker: "Sent to Worker",
  status_in_manufacturing: "In Manufacturing",
  status_under_inspection: "Under Inspection",
  status_sent_for_polishing: "Sent for Polishing",
  status_polishing_in_progress: "Polishing in Progress",
  status_ready: "Ready",
  status_ready_for_delivery: "Ready for Delivery",
  status_partially_ready: "Partially Ready",
  status_partially_delivered: "Partially Delivered",
  status_billed: "Billed",
  status_repair_in_progress: "Repair in Progress",

  type_custom: "Custom Order",
  type_repair: "Repair",
  type_polishing: "Polishing",
  type_ready_stock: "Ready Stock Sale",
  type_wholesale: "Wholesale / Bulk",

  priority_normal: "Normal",
  priority_high: "High",
  priority_urgent: "Urgent",

  priorityLabel: "Priority",
  orderSlip: "Order Slip",
  oldGoldReceipt: "Gold Received from Customer Receipt",
  customerGoldReceipt: "Customer Gold Receipt",
  advanceReceipt: "Advance Receipt",
  createOrderSubtitle:
    "Step-by-step order intake. Nothing is saved until you confirm or save a draft.",
  step_1: "Order Type",
  step_2: "Customer",
  step_3: "Design",
  step_4: "Item & Gold",
  step_5: "Advance / Gold In",
  step_6: "Assignment",
  step_7: "Confirm",
};

export default translations;
